function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M51.035 98.77c-12.906-.387-20.993-.951-25.047-1.748-2.337-.459-4.858-1.801-6.537-3.48-2.86-2.861-3.871-6.158-4.668-15.224-1.263-14.364-.35-33.636 1.877-39.588 1.178-3.149 4.378-6.192 7.643-7.267 8.826-2.907 67.267-3.052 78.44-.194 2.417.618 3.842 1.441 5.704 3.296 1.948 1.94 2.697 3.237 3.392 5.874 2.6 9.861 2.601 37.043.002 47.293-.635 2.502-1.453 3.943-3.305 5.819-3.06 3.1-5.707 3.867-15.692 4.551-6.697.459-12.62.613-25.826.671-7.611.034-14.804.033-15.983-.003z",
    className: "icon_svg__black",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.692 78.915V48.814L79.997 64z",
    className: "icon_svg__white",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgIcon;